import { Checkbox, FormControlLabel } from "@material-ui/core";
import AddressGroup from "../ui/AddressGroup";
import SectionCard from "../ui/SectionCard";
import { MapPinIcon } from "../ui/icons";
import { rv } from "../tokens";
import { StepViewProps } from "./types";

export default function AddressDetails({ state, isTier3, handlers }: StepViewProps) {
  const { draft, errors, sameAsPresentAddress } = state;
  const onField = (path: string, value: string) => handlers.setKycField(path, value);

  return (
    <>
      <SectionCard title="Current address" icon={<MapPinIcon size={18} />}>
        <AddressGroup
          basePath="currentAddress"
          address={draft.kyc.currentAddress || {}}
          errors={errors}
          onField={onField}
        />
      </SectionCard>

      {isTier3 && (
        <>
          <SectionCard title="Permanent address" icon={<MapPinIcon size={18} />}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={sameAsPresentAddress}
                  color="primary"
                  onChange={(event) => handlers.setSameAsPresent(event.target.checked)}
                />
              }
              label="Same as current address"
            />
            {sameAsPresentAddress ? (
              <p style={{ margin: "2px 0 0", fontSize: 13, color: rv.muted }}>
                Your permanent address will be saved as the same as your current address.
              </p>
            ) : (
              <div style={{ marginTop: 8 }}>
                <AddressGroup
                  basePath="permanentAddress"
                  address={draft.kyc.permanentAddress || {}}
                  errors={errors}
                  onField={onField}
                />
              </div>
            )}
          </SectionCard>
          <SectionCard title="Work / business address" icon={<MapPinIcon size={18} />}>
            <AddressGroup
              basePath="businessAddress"
              address={draft.kyc.businessAddress || {}}
              errors={errors}
              onField={onField}
            />
          </SectionCard>
        </>
      )}
    </>
  );
}
